import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import { AuthProvider } from './AuthContext.jsx'
import "./index.css";

// Initialize PWA install prompt
import { registerInstallPrompt } from './pwa/installPrompt.js';
registerInstallPrompt();

// Initialize status bar for Capacitor
import { Capacitor } from '@capacitor/core';
import { initStatusBar } from './capacitor/statusBar';

// Initialize status bar when Capacitor is ready
if (Capacitor.getPlatform() === 'android') {
  initStatusBar();
}

ReactDOM.createRoot(document.getElementById('root')).render(
  // StrictMode disabled during stream stabilization to prevent double-mount
  // <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  // </React.StrictMode>
)

// Handle dynamic import failures (e.g., stale chunk names after deploy)
if (typeof window !== 'undefined') {
  const onceKey = '__ppac_reloaded_after_chunk_error__';
  window.addEventListener('error', (e) => {
    // Vite/React surfaces Module script load errors as generic Errors in some browsers
    const target = e?.target;
    // If a script or link fails to load, force a one-time reload
    if ((target?.tagName === 'SCRIPT' || target?.tagName === 'LINK') && !sessionStorage.getItem(onceKey)) {
      sessionStorage.setItem(onceKey, '1');
      window.location.reload();
    }
  }, true);

  window.addEventListener('unhandledrejection', (event) => {
    const msg = String(event?.reason?.message || event?.reason || '');
    // Typical message: Failed to fetch dynamically imported module
    if (msg.includes('Failed to fetch dynamically imported module') && !sessionStorage.getItem(onceKey)) {
      sessionStorage.setItem(onceKey, '1');
      window.location.reload();
    }
  });
}

// Service worker update UX: listen for a waiting SW and prompt reload
// Only register service worker in production to avoid conflicts with Firebase in development
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    // Force clear any existing caches on page load
    if ('caches' in window) {
      caches.keys().then(cacheNames => {
        cacheNames.forEach(cacheName => {
          caches.delete(cacheName);
        });
      });
    }
    
    navigator.serviceWorker.register('/sw.js').then(async (reg) => {
      if (!reg) return;
      
      function showUpdatePrompt() {
        // Minimal: confirm then activate new SW
        const ok = window.confirm('A new version is available. Update now?');
        if (ok && reg.waiting) {
          reg.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
      }
      
      if (reg.waiting) showUpdatePrompt();
      
      reg.addEventListener('updatefound', () => {
        const sw = reg.installing;
        if (!sw) return;
        sw.addEventListener('statechange', () => {
          if (sw.state === 'installed' && reg.waiting) showUpdatePrompt();
        });
      });
      
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        // Force reload and clear cache
        window.location.reload();
      });
      
      // Register periodic background sync (best-effort)
      try {
        if ('periodicSync' in reg && navigator.permissions) {
          // Request permission gracefully
          try { await navigator.permissions.query({ name: 'periodic-background-sync' }); } catch {}
          // 24h interval
          // @ts-ignore
          await reg.periodicSync.register('ppac-refresh', { minInterval: 24 * 60 * 60 * 1000 });
        }
      } catch {}
    }).catch(() => {/* noop */})
  })
}
